import { render, staticRenderFns } from "./SearchOrderItem.vue?vue&type=template&id=147bfe50&scoped=true&"
import script from "./SearchOrderItem.vue?vue&type=script&lang=js&"
export * from "./SearchOrderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147bfe50",
  null
  
)

export default component.exports